import { LinkPlainInternal } from 'src/elements/links/Link.plain';
import styled, { css } from 'styled-components';

const sharedSidebarLinkStyles = css`
  color: var(--sidebar-text-color-theme);
  font-size: 2.5rem;
  font-family: 'Walsheim';
  font-weight: 700;
  text-align: left;
  text-decoration: none;

  // Non-standard MQ, adjust height to avoid link clutter
  @media all and (max-height: 750px) {
    font-size: 2rem;
  }
  @media all and (max-height: 670px) {
    font-size: 1.5rem;
  }
`;

export const SideBarStandardLink = styled(LinkPlainInternal)`
  ${sharedSidebarLinkStyles}
  transition: filter 200ms ease-in-out;

  &:hover {
    filter: brightness(0.8);
  }
`;

export const SideBarExpandableToggle = styled.div`
  ${sharedSidebarLinkStyles}
  align-self: center;
  display: inline-flex;
  cursor: pointer;
  column-gap: 6px;

  path {
    fill: var(--sidebar-text-color-theme);
  }
`;

export const SideBarExpandableToggleContent = styled.div``;
